import React, { useState, useRef } from "react";
import DayPicker from "react-day-picker";
import "moment/locale/pt-br";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Container,
  DropdownContainer,
  DateAvailableIcon,
  DateDescription,
  OpenDate,
  LabelContainer,
  LabelItem,
} from "./styles";
import useOutsideClickDropdown from "~/hooks/useOutsideClickDropdown";
import "react-day-picker/lib/style.css";

export default function NewDatePicker({ setShowDatepicker, edit, setDisableButton }) {
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ];
  const WEEKDAYS_SHORT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");

  const orderReducer = useSelector((state) => state.orderReducer);
  const orderEditReducer = useSelector(state => state.orderEditReducer);

  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  useOutsideClickDropdown(dropdownRef, setShowDropdown, setShowDatepicker);

  const handleDayClick = (day, modifiers = {}, { selected }) => {
    if (modifiers.disabled) {
      return;
    }
    setShowDropdown();
    setShowDatepicker(false);

    const formatDay = moment(day).format("DD/MM/YYYY");
    if(edit) {
      setDisableButton(false);
      dispatch({ type: "ADD_DATE_EDIT", date: formatDay });
    } else {
      dispatch({ type: "ADD_DATE", date: formatDay });
    }
    setSelectedDay(day);
  };

  const today = new Date();
  today.setDate(today.getDate() + 1);

  const maximumDate = new Date();
  maximumDate.setDate(maximumDate.getDate() + 1);
  maximumDate.setDate(maximumDate.getDate() + 31);

  return (
    <>
      <Dropdown show={showDropdown} ref={dropdownRef} id="datepicker">
        <DropdownContainer
          as={Dropdown.Toggle}
          onClick={() => {
            setShowDropdown(!showDropdown);
            setShowDatepicker(!showDropdown);
          }}
          id="dropdown-basic"
          style={{
            width: "92%",
            backgroundColor: "#ffffff",
            boxShadow: "0 0 0 0.2rem rgba(38,143,255,.0)",
            border: "1px solid rgba(80, 80, 80, 0.3)",
            color: "#808495",
            fontSize: "0.9rem",
            textAlign: "left",
          }}
        >
          {selectedDay
            ? moment(selectedDay).format("DD/MM/YYYY")
            : (
              <>
                {
                  edit ? (
                    <>
                      {
                        orderEditReducer.date !== "" ? orderEditReducer.date : "DD/MM/AAAA"
                      }
                    </>
                  ) : (
                    <>
                      {
                        orderReducer.date !== "" ? orderReducer.date : "DD/MM/AAAA"
                      }
                    </>
                  ) 
                }
              </>
            )}
        </DropdownContainer>
        <Container as={Dropdown.Menu}>
          <DayPicker
            fromMonth={new Date()}
            toMonth={maximumDate}
            disabledDays={[{ before: today }]}
            onDayClick={handleDayClick}
            months={MONTHS}
            weekdaysLong={WEEKDAYS_LONG}
            weekdaysShort={WEEKDAYS_SHORT}
            selectedDays={selectedDay}
            enableOutsideDaysClick={true}
          />
          <LabelContainer>
            <LabelItem>
              <DateAvailableIcon className="fa fa-fw fa-circle" />
              <DateDescription> Datas indisponíveis</DateDescription>
            </LabelItem>
            <LabelItem>
              <OpenDate className="fa fa-fw fa-circle"></OpenDate>
              <DateDescription> Datas em aberto</DateDescription>
            </LabelItem>
          </LabelContainer>
        </Container>
      </Dropdown>
    </>
  );
}
